export default "__VITE_ASSET__VzgRfFIw__"